export interface CurrencyAmountCapability {
  amount_scale: number;
  amount_step: string;
  min_amount: string;
  max_amount: string | null;
}

export const sanitizeCurrencyAmount = (value: string | undefined, scale = 6) => {
  if (!value) return value;
  const normalized = value.replace(',', '.').replace(/[^0-9.]/g, '');
  const [whole = '', ...fraction] = normalized.split('.');
  return fraction.length ? `${whole}.${fraction.join('').slice(0, scale)}` : whole;
};

export const validateCurrencyAmount = (value: string, currency?: CurrencyAmountCapability) => {
  if (!currency || !value) return 'Выберите валюту и укажите сумму';
  const amount = Number(value);
  if (!Number.isFinite(amount) || amount <= 0) return 'Сумма должна быть больше нуля';
  if ((value.split('.')[1]?.length || 0) > currency.amount_scale) {
    return `Допустимо не более ${currency.amount_scale} знаков после запятой`;
  }
  if (amount < Number(currency.min_amount)) return `Минимальная сумма: ${currency.min_amount}`;
  if (currency.max_amount && amount > Number(currency.max_amount)) return `Максимальная сумма: ${currency.max_amount}`;
  if (!isStepMultiple(value, currency.amount_step, currency.amount_scale)) {
    return `Сумма должна быть кратна шагу ${currency.amount_step}`;
  }
  return null;
};

const toScaledDigits = (value: string, scale: number) => {
  const [whole = '0', fraction = ''] = value.replace(',', '.').split('.');
  const digits = `${whole || '0'}${fraction.padEnd(scale, '0').slice(0, scale)}`;
  return digits.replace(/^0+(?=\d)/, '');
};

const isStepMultiple = (value: string, stepValue: string, scale: number) => {
  const stepDigits = toScaledDigits(stepValue, scale);
  const divisor = Number(stepDigits);
  if (!Number.isSafeInteger(divisor) || divisor <= 0) return true;

  let remainder = 0;
  for (const digit of toScaledDigits(value, scale)) {
    remainder = (remainder * 10 + Number(digit)) % divisor;
  }
  return remainder === 0;
};
